module.exports = __webpack_public_path__ + "img/ui-challenge-banner.49e480ee.jpg";